import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const Privacy = () => <LegalPageLayout namespace="privacy" sectionCount={8} />;

export default Privacy;
